/**
 * ProductCompare
 * @description Web component used to compare products
 */

(async () => {
  if (!customElements.get('product-compare')) {

    class ProductCompare extends HTMLElement {
      constructor() {
        super();

        this.productLists = this.querySelectorAll('[data-compare-detail-list]');

        this.productLists.forEach((productList) => {
          const index = productList.dataset.compareDetailList;
          productList.addEventListener('change', (event) => {
            this.updateProductList(event, index);
          });

          // Trigger a change event on the select to show the selected product data
          productList.dispatchEvent(new Event('change'));
        });
      }

      /**
       * Static function to handle clicks on [data-compare-button] elements anywhere in the document
       * @param {Event} event - The click event
       */
      static handleCompareButtonClick(event) {
        const compareButton = event.target.closest('[data-compare-button]');
        if (compareButton) {
          event.preventDefault();

          const firstCompareSelect = this.querySelector('[data-compare-detail-list="1"]');
          const url = compareButton.dataset.compareButton;

          // update the first select element with the url
          firstCompareSelect.value = url;
          firstCompareSelect.dispatchEvent(new Event('change'));

          // scroll to product-compare
          document.querySelector('#product-compare').scrollIntoView({ behavior: 'smooth' });
        }
      }

      updateProductList(event, index) {
        const url = `${event.target.value}?section_id=product-compare-data`
        fetch(url)
          .then((response) => response.text())
          .then((data) => {
            this.querySelector(`[data-compare-detail-column="${index}"]`).innerHTML = data;
            this.updateProductCompare(data, index);
          });
      }

      updateProductCompare(data, index) {
        const grid = this.querySelector('[data-compare-detail-grid]');
        const column = grid.querySelectorAll(`[data-compare-detail-column="${index}"]`);
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        column.forEach((cell) => {

          const type = cell.dataset.compareDetailRow;
          // Parse the HTML string into a DOM element
          const cellData = html.querySelector(`[data-detail-type="${type}"]`);
          cell.innerHTML = cellData ? cellData.innerHTML : '<span data-compare-no-data>-</span>';
        });

        // After updating all cells, check which rows should be hidden
        this.updateRowVisibility();
      }

      updateRowVisibility() {
        const grid = this.querySelector('[data-compare-detail-grid]');
        const allRows = grid.querySelectorAll('[data-compare-detail-row]');
        const rowTypes = [...new Set(Array.from(allRows).map(row => row.dataset.compareDetailRow))];

        rowTypes.forEach(rowType => {
          const cellsInRow = grid.querySelectorAll(`[data-compare-detail-row="${rowType}"]`);
          const noDataCells = Array.from(cellsInRow).filter(cell =>
            cell.querySelector('[data-compare-no-data]')
          );

          // Hide the entire row if all 3 cells have no data
          if (noDataCells.length === 3) {
            cellsInRow.forEach(cell => {
              cell.style.display = 'none';
            });
          } else {
            cellsInRow.forEach(cell => {
              cell.style.display = '';
            });
          }
        });
      }
    }

    // Add document-level event listener for compare button clicks
    document.addEventListener('click', ProductCompare.handleCompareButtonClick);

    window.ProductCompare = ProductCompare;

    customElements.define('product-compare', ProductCompare);
  }
})();
